var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 125 63",
    style: {
      enableBackground: "new 0 0 125 63"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#efd162;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.6,56.2c-2.3-1-4.3-2.4-6.1-4l1.5-2.7c0.4-0.6,0.9-1.1,1.5-1.4s1.3-0.5,2.1-0.5c0.8,0,1.6,0.2,2.3,0.5 c1.3,0.6,2.4,1.1,3.5,1.5s2.1,0.6,3.3,0.6c1.6,0,2.9-0.4,3.8-1.1c0.9-0.7,1.4-1.8,1.4-3.1c0-1-0.5-1.8-1.4-2.6S34.1,41.8,32,41 c-2.9-1.1-5.1-2.2-6.7-3.3c-1.6-1.1-2.6-2.3-3.2-3.6c-0.6-1.3-0.9-2.8-0.9-4.6c0-2.2,0.5-4.1,1.4-5.7s2.3-2.9,4.1-3.8 s3.9-1.4,6.3-1.4c1.9,0,3.9,0.4,6,1.1c2,0.7,3.7,1.7,5.1,3.1l-1.4,2.8c-0.3,0.7-0.8,1.2-1.5,1.6c-0.7,0.4-1.4,0.6-2.2,0.6 c-0.6,0-1.3-0.1-2-0.4c-0.2-0.1-0.6-0.2-1.1-0.4s-0.9-0.3-1.4-0.4s-0.9-0.2-1.3-0.2c-1.3,0-2.3,0.3-3,0.8c-0.7,0.6-1,1.4-1,2.4 c0,0.9,0.4,1.6,1.1,2.2c0.7,0.6,2,1.2,3.9,1.9c4,1.5,6.9,3.1,8.8,5c1.9,1.9,2.8,4.2,2.8,7.2c0,2.4-0.6,4.5-1.7,6.3 s-2.8,3.2-4.9,4.2c-2.1,1-4.5,1.5-7.3,1.5C29.4,57.8,26.9,57.3,24.6,56.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.4,53.7c-1.8,1.1-3.8,2.1-5.8,2.9s-4.3,1.2-6.6,1.2s-4.4-0.5-6.1-1.5c-1.8-1-3.1-2.4-4.1-4.2 c-1-1.8-1.5-4-1.5-6.5V26.8h-6.6v-4.9c0-0.8,0.3-1.5,0.8-1.9c0.5-0.4,1.1-0.7,1.8-0.7h4l0.1-9.9c0-0.9,0.3-1.7,0.8-2.4 c0.5-0.6,1.3-0.9,2.2-0.9h4.9v13.2h10.7v7.5H65.5v16.9c0,2,0.5,3.5,1.5,4.6c1,1.1,2.3,1.6,4,1.6c0.7,0,1.4-0.1,2-0.3 c0.6-0.2,1.3-0.5,2.1-0.9c0.7-0.3,1.4-0.5,2.1-0.5c0.7,0,1.3,0.1,1.8,0.4s0.9,0.7,1.1,1.3L81.4,53.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.1,22.8c2.3,2.8,3.4,6.8,3.4,11.9v22.3h-8.1V35.7c0-3.2-0.6-5.5-1.8-7c-1.2-1.5-3-2.2-5.3-2.2 c-1.6,0-3.3,0.4-5,1.2c-1.7,0.8-3.3,1.9-4.8,3.3v26.1h-8.1V19.2h5.4c1,0,1.7,0.3,2.1,0.9c0.4,0.6,0.6,1.4,0.6,2.4v0.6 c1.6-1.4,3.3-2.6,5.3-3.4c2-0.8,4.1-1.2,6.3-1.2C110.6,18.6,113.9,20,116.1,22.8z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 8,
    cy: 53,
    r: 4.8
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3975e0e7786d2e59a62adff31fb4cf49.svg";
export { ForwardRef as ReactComponent };